export const DEFAULT_DOCUMENT_TITLE = '神ゲー攻略 Wiki 管理画面';

export const LOCAL_STORAGE_KEYS = {
  IS_POPUP_IMAGE_INSERT_MODE: 'isPopupImageInsertMode',
};
